import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import App from './Components/App';

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

